
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
name: "repair",
components: {XHeader, XInput, Group, XButton, Cell, XTextarea, Previewer},
data() {
return {
orderDetail: {},
address: '',
seq: this.$route.query.seq,
role: this.$route.query.role,
list: []
}
},
methods: {
callPhone(phoneNumber) {
window.location.href = 'tel://' + phoneNumber
},
goRepairSolution() {
this.$router.push({
name: 'RepairSolution',
params: {
solution: this.orderDetail.solution,
seq: this.orderDetail.seq,
role: this.role,
type: '',
solutionv: this.orderDetail.solutionv,
show: false
}
})
}
},
created() {
const openid = localStorage.getItem('openid');
const unionid = localStorage.getItem('unionid')
this.$http.get('/api/v1/wechat/' + unionid).then(response => {



response.data.forEach(item => {
if (item.role === this.role) {
this.$http.post('api/v1/wechat/' + unionid + '/token', {'account': item.account})
.then(res => {
const obj = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
this.$http.get('api/v1/normalrepairs/' + this.seq + '?role=' + this.role + '&type=detail', obj).then(response => {
this.orderDetail = response.data.detail
this.orderDetail.sevenday = this.orderDetail.sevenday ? '是' : '否'
this.orderDetail.isviwo = this.orderDetail.isviwo ? '是' : '否'
this.address = this.orderDetail.province + ' ' + this.orderDetail.city + " " + this.orderDetail.district
switch (this.orderDetail.userconfirm) {
case 'ACCEPT':
this.orderDetail.userconfirm = '接受'
break
case 'WAIT1':
this.orderDetail.userconfirm = '等待确认'
break
case 'WAIT2':
this.orderDetail.userconfirm = '等待确认'
break
case 'REJECT':
this.orderDetail.userconfirm = '拒绝'
break
case 'ARBIT':
this.orderDetail.userconfirm = '提交仲裁'
break
case 'A_ACCEPT':
this.orderDetail.userconfirm = '后台自动确认'
break
}
switch (this.orderDetail.state) {
case 'WAIT':
this.orderDetail.state = '待处理'
break
case 'PROCESS':
this.orderDetail.state = '处理中'
break
case 'FAIL':
this.orderDetail.state = '失败'
break
case 'SUCCESS':
this.orderDetail.state = '成功'
break
}
this.list = [];
if (this.orderDetail.signature && this.orderDetail.signature.content.length !== 0) {
this.orderDetail.signature.content[0].path.forEach(item => {
this.$http.get('/api/photos?path=' + item, obj).then(paths => {
this.list.push({src: paths.data['value']});
console.log(this.list)
});
});
}
}).catch(error => {
console.log(error)
})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).faultstring,
type: 'cancel',
time: '1000'
})
});
}
})
})
},
}



// WEBPACK FOOTER //
// ./src/components/repair.vue